<template>
  <v-container v-if="personal" fluid>
    <v-row>
      <v-col cols="4">
        <v-btn text class="mx-2" v-on:click="$router.go(-1)"
          ><v-icon>mdi-arrow-left</v-icon> Volver a catálogo de personal</v-btn
        >
      </v-col>
      <v-col cols="8" align="right">
        <v-spacer></v-spacer>
        <v-btn
          v-on:click="download(personal.foto)"
          rounded
          color="secondary"
          class="mx-2"
          v-if="personal.foto.length > 0"
          >Descargar fotografía</v-btn
        >
      </v-col>
      <v-col cols="3">
        <v-row>
          <v-col cols="12">
            <personal-card-component :personal="personal" :enrolamiento="enrolamiento[0]"></personal-card-component>
          </v-col>
          <v-col cols="12">
            <menu-list-component :loading="loadingPersonalData" :estatus="personal.fk_idEstatus"></menu-list-component>
          </v-col>
        </v-row>
      </v-col>
      <template v-if="loadingPersonalData == false">
        <v-col cols="9">
          <datos-generales-component
            v-if="selectedMenu == 1"
            :personal="personal"
            :estudios="estudiosPersonal"
          ></datos-generales-component>
          <referencias-component
            v-if="selectedMenu == 2"
            :personal="personal"
            :referencias="referencias"
            :familiares="familiares"
          ></referencias-component>
          <documentos-component
            v-if="selectedMenu == 3"
            :documentos="documentos"
            :id="personal.idPersonal"
          ></documentos-component>
          <desarrollo-elemento-component
            v-if="selectedMenu == 4"
            :evaluaciones="evaluacionesMedicas"
            :dictamenes="dictamenes"
            :biometricos="biometricosPersonal"
            :cursos="cursos"
            :evaluaciones-productividad="evaluacionesPersonalProductividad"
            :armas="armasPersonal"
            :equipamiento="equipamientoPersonal"
            :estatus="personal.fk_idEstatus"
          ></desarrollo-elemento-component>
          <puesto-dependencia-component v-if="selectedMenu == 5" :personal="personal"></puesto-dependencia-component>
          <area-adscripcion-component v-if="selectedMenu == 6" :personal="personal"></area-adscripcion-component>
          <faltas-administrativas-component
            v-if="selectedMenu == 8"
            :faltas="faltasAdministrativas"
          ></faltas-administrativas-component>
          <linea-tiempo-component v-if="selectedMenu == 7" :permutaciones="permutaciones"></linea-tiempo-component>
          <media-filiacion-component
            v-if="selectedMenu == 9"
            :media-filiacion="personal.mediafiliacion"
            :senias-particulares="personal.seniasParticulares"
            :personal="personal"
          ></media-filiacion-component>
          <carrera-policial-component
            v-if="selectedMenu == 11"
            :convocatorias="convocatorias"
            :condecoraciones="condecoraciones"
            :personal="personal"
          ></carrera-policial-component>
        </v-col>
      </template>
      <template v-else>
        <v-col cols="9">
          <v-skeleton-loader type="image" height="100%"></v-skeleton-loader>
        </v-col>
      </template>
    </v-row>
  </v-container>
</template>
<style scoped>
.selectable {
  cursor: pointer;
}
</style>
<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import moment from 'moment'
import PersonalCardComponent from '../../components/expediente/PersonalCardComponent.vue'
import MenuListComponent from '../../components/expediente/MenuListComponent.vue'
import DatosGeneralesComponent from '../../components/expediente/DatosGeneralesComponent.vue'
import DocumentosComponent from '../../components/expediente/DocumentosComponent.vue'
import DesarrolloElementoComponent from '../../components/expediente/DesarrolloElemento.vue'
import AreaAdscripcionComponent from '../../components/expediente/AreaAdscripcionComponent.vue'
import ReferenciasComponent from '../../components/expediente/ReferenciasComponent.vue'
import PuestoDependenciaComponent from '../../components/expediente/PuestoDependenciaComponent'
import FaltasAdministrativasComponent from '../../components/expediente/FaltasAdministrativasComponent.vue'
import FamiliaresComponent from '../../components/expediente/FamiliaresComponent.vue'
import LineaTiempoComponent from '../../components/expediente/LineaTiempoComponent.vue'
import MediaFiliacionComponent from '../../components/expediente/MediaFiliacionComponent.vue'
import CarreraPolicialComponent from '../../components/expediente/CarreraPolicialComponent.vue'

export default {
  components: {
    PersonalCardComponent,
    MenuListComponent,
    DatosGeneralesComponent,
    DocumentosComponent,
    DesarrolloElementoComponent,
    AreaAdscripcionComponent,
    ReferenciasComponent,
    PuestoDependenciaComponent,
    FaltasAdministrativasComponent,
    FamiliaresComponent,
    LineaTiempoComponent,
    MediaFiliacionComponent,
    CarreraPolicialComponent,
  },

  async mounted() {
    this.SET_SELECTED_MENU(1)
    this.loadingPersonalData = true
    await Promise.all([
      this.fetchPersonalById(this.id),
      this.fetchEstudiosByPersonal(this.id),
      this.fetchDocumentoByPersonal(this.id),
      this.fetchEvaluacionMedicaByPersonal(this.id),
      this.fetchDictamenPersonal(this.id),
      this.fetchArmasPersonal(this.id),
      this.fetchBiometricosPersonal(this.id),
      this.fetchAsignacionEquipoByPersonal(this.id),
      this.fetchCursosAsignadosByPersonal(this.id),
      this.fetchReferenciasByPersonal(this.id),
      this.fetchFaltasAdministrativasByPersonal(this.id),
      this.fetchFamiliaresByPersonal(this.id),
      this.fetchPermutacionesByPersonal(this.id),
      this.fetchConvocatoriaPersonal(this.id),
      this.fetchCondecoracionPersonal(this.id),
      this.fetchCadenaResultados(this.id),
      this.fetchCadenaResultadosDesempeñoAcademico(this.id),
      this.fetchEnrolamientoByPersonal(this.id),
      this.fetchRespetoPrincipiosValores(this.id),
      this.fetchDesempeñoInstitucional(this.id),
      this.fetchRendimientoProfesionalismo(this.id),
      this.fetchEvaluacionAnual(this.id),
    ])

    this.loadingPersonalData = false
  },

  props: {
    id: {
      type: Number,
    },
  },

  data() {
    return {
      nameRules: [(v) => !!v || 'Este campo es requerido.'],
      loadingPersonalData: false,

      estadoNace: null,
      municipioNace: null,
      estadoRadica: null,
      municipioRadica: null,
      estadoDireccion: null,
      municipioDireccion: null,
      saveChanges: false,

      menuNacimiento: false,
      date: null,
    }
  },

  watch: {
    menuNacimiento(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
    },
  },

  computed: {
    ...mapGetters('personal', {
      personal: 'getPersonalSingle',
    }),

    ...mapGetters('estudio', {
      estudios: 'getEstudios',
    }),

    ...mapGetters('documento', {
      documentos: 'getDocumentos',
    }),

    ...mapGetters('tipoNacionalidad', {
      tipoNacionalidad: 'getTipoNacionalidad',
    }),

    ...mapGetters('municipio', {
      municipios: 'getMunicipios',
    }),

    ...mapGetters('estado', {
      estados: 'getEstados',
    }),

    ...mapGetters('sexo', {
      sexo: 'getSexo',
    }),

    ...mapGetters('armaPersonal', {
      armasPersonal: 'getArmasPersonal',
    }),

    ...mapGetters('biometrico', {
      biometricosPersonal: 'getBiometricosPersonal',
    }),

    ...mapGetters('asignacionEquipo', {
      equipamientoPersonal: 'getAsignacionesEquipo',
    }),

    ...mapGetters('cursoAsignado', {
      cursos: 'getCursosAsignadosPersonal',
    }),

    ...mapGetters('productividad', {
      evaluacionesProductividad: 'getProductividad',
    }),

    ...mapGetters('respetoPrincipios', {
      evaluacionesRespetoPrincipios: 'getRespetoPrincipios',
    }),

    ...mapGetters('expediente', {
      selectedMenu: 'getSelectedMenu',
    }),

    ...mapGetters('evaluacionMedica', {
      evaluacionesMedicas: 'getEvaluacionMedica',
    }),

    ...mapGetters('dictamenPersonal', {
      dictamenes: 'getDictamenPersonal',
    }),

    ...mapGetters('referencias', {
      referencias: 'getReferencias',
    }),

    ...mapGetters('permutacion', {
      permutaciones: 'getPermutaciones',
    }),

    ...mapGetters('faltasAdministrativas', {
      faltasAdministrativas: 'getFaltasAdministrativas',
    }),

    ...mapGetters('familiares', {
      familiares: 'getFamiliares',
    }),

    ...mapGetters('convocatoriaPersonal', {
      convocatorias: 'getConvocatoriaPersonal',
    }),

    ...mapGetters('condecoracionPersonal', {
      condecoraciones: 'getCondecoracionPersonal',
    }),

    ...mapGetters('enrolamiento', {
      enrolamiento: 'getEnrolamientos',
    }),

    menu: function () {
      return []
    },

    estudiosPersonal: function () {
      if (this.estudios) {
        return this.estudios.filter((estudio) => {
          return estudio.fk_idPersonal == this.id
        })
      } else return []
    },

    cursosPersonal: function () {
      if (this.cursos) {
        return this.cursos.filter((cursoAsignado) => {
          return cursoAsignado.fk_idPersonal == this.id
        })
      } else return []
    },

    evaluacionesPersonalProductividad: function () {
      if (this.evaluacionesProductividad) {
        return this.evaluacionesProductividad.filter((evaluacion) => {
          return evaluacion.fk_idPersonal == this.id
        })
      } else return []
    },

    evaluacionesPersonalRespetoPrincipios: function () {
      if (this.evaluacionesRespetoPrincipios) {
        return this.evaluacionesRespetoPrincipios.filter((evaluacion) => {
          return evaluacion.fk_idPersonal == this.id
        })
      } else return []
    },
  },

  methods: {
    ...mapActions('comprobanteEstudios', ['fetchComprobantesEstudios']),
    ...mapActions('documento', ['fetchDocumentoByPersonal']),
    ...mapActions('estudio', ['fetchEstudiosByPersonal']),
    ...mapActions('evaluacionMedica', ['fetchEvaluacionMedicaByPersonal']),
    ...mapActions('dictamenPersonal', ['fetchDictamenPersonal']),
    ...mapActions('estatusDocumento', ['updateEstatusDocumento']),
    ...mapActions('personal', ['fetchPersonalById']),
    ...mapActions('armaPersonal', ['fetchArmasPersonal']),
    ...mapActions('biometrico', ['fetchBiometricosPersonal']),
    ...mapActions('asignacionEquipo', ['fetchAsignacionEquipoByPersonal']),
    ...mapActions('cursoAsignado', ['fetchCursosAsignadosByPersonal']),
    ...mapActions('referencias', ['fetchReferenciasByPersonal']),
    ...mapActions('faltasAdministrativas', ['fetchFaltasAdministrativasByPersonal']),
    ...mapActions('familiares', ['fetchFamiliaresByPersonal']),
    ...mapActions('permutacion', ['fetchPermutacionesByPersonal']),
    ...mapActions('enrolamiento', ['fetchEnrolamientoByPersonal']),
    ...mapActions('convocatoriaPersonal', ['fetchConvocatoriaPersonal']),
    ...mapActions('condecoracionPersonal', ['fetchCondecoracionPersonal']),
    ...mapActions('cadenaResultados', ['fetchCadenaResultados', 'fetchCadenaResultadosDesempeñoAcademico']),
    ...mapMutations('expediente', ['SET_SELECTED_MENU']),
    ...mapActions('respetoPrincipiosValores', ['fetchRespetoPrincipiosValores']),
    ...mapActions('desempeñoInstitucional', ['fetchDesempeñoInstitucional']),
    ...mapActions('rendimientoProfesionalismo', ['fetchRendimientoProfesionalismo']),
    ...mapActions('evaluacionAnual', ['fetchEvaluacionAnual']),

    selectMenu: function (menu) {
      this.selectedMenu = menu
    },

    download: function (url) {
      window.open(url, '_blank')
    },

    downloadQr: function (cuip) {
      window.open('http://ssctlaxcala.eonproduccion.net/qr/?cuip=' + cuip, '_blank')
    },

    save(date) {
      this.$refs.menu.save(date)
      this.personal.fechaNacimiento = moment(date).format(this.API_DATE_FORMAT)
    },
  },
}
</script>
